enum AccessLevel {
    EXECUTIVE = 'E',
    OVERRIDE = 'O', // Override (use this for admin)
    STANDARD = 'S',
}

export default AccessLevel;
